module.exports = __webpack_public_path__ + "img/icc.9f91f1a0.png";